import { initializeOctopusClient } from '@pegasus/abtesting';

import { apiPrefix, pendingAssignments } from '@shared/assignments';

export const {
    getReducer: getOctopusReducer,
    middleware: octopusMiddleware,
    useAssignment,
    useLazyAssignment,
    useLazyVariant,
    useVariant,
} = initializeOctopusClient({
    apiPrefix,
    pendingAssignments,
});
